import { createSelector } from '@reduxjs/toolkit';

import { isDefined, isEmpty } from '@hsp/utilities';

import { ApplicationState } from 'types/store';

const selectState = (state: ApplicationState) => state.user;

export const selectUser = createSelector(selectState, ({ user }) => user);

export const selectIsAuthenticated = createSelector(selectUser, (user) => isDefined(user) && !isEmpty(user));

export const selectDisplayName = createSelector(selectUser, (user) => user?.displayName);

export const selectEmail = createSelector(selectUser, (user) => user?.email);

export const selectProfileImage = createSelector(selectUser, (user) => user?.profileImage);

export const selectRoles = createSelector(selectUser, (user) => {
  if (!isDefined(user) || isEmpty(user?.role)) {
    return [];
  }

  const { role } = user;

  if (typeof role === 'string') {
    return [role];
  }

  return role.map((userRole) => userRole.toLowerCase());
});

export const selectUsername = createSelector(selectUser, (user) => user?.email);
export const selectUserId = createSelector(selectUser, (user) => user?.userId);
